<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.workflow_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/work/workflow/workflow";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "主键",
                                    prop: "id",
                                    rules: [{
                                        required: true,
                                        message: "请输入主键",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "流程编码",
                                    prop: "flowCode",
                                    rules: [{
                                        required: true,
                                        message: "请输入流程编码",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "流程名称",
                                    prop: "flowName",
                                    rules: [{
                                        required: true,
                                        message: "请输入流程名称",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "备注",
                                    prop: "remark",
                                    rules: [{
                                        required: true,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.workflow_add, false),
                    viewBtn: this.vaildData(this.permission.workflow_view, false),
                    delBtn: this.vaildData(this.permission.workflow_delete, false),
                    editBtn: this.vaildData(this.permission.workflow_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
